import { render } from "./form-content-review.vue?vue&type=template&id=703c5c98&scoped=true"
import script from "./form-content-review.vue?vue&type=script&lang=js"
export * from "./form-content-review.vue?vue&type=script&lang=js"

import "./form-content-review.vue?vue&type=style&index=0&id=703c5c98&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703c5c98"],['__file',"src/components/notepad/parts/form-content-review.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "703c5c98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('703c5c98', __exports__)) {
    api.reload('703c5c98', __exports__)
  }
  
  module.hot.accept("./form-content-review.vue?vue&type=template&id=703c5c98&scoped=true", () => {
    api.rerender('703c5c98', render)
  })

}


export default __exports__